export default class Storage {
    constructor() {
        // This class dispatches events when the database contents get changed
        // The various components listen for this to refresh their display
        this.log = false;
    }

    initialize() {
        if (this.log) console.log('storage.initialize()');
        let self = this;

        self.idb = null;
        return new Promise(function(resolve, reject) {
            try {
                let request = window.indexedDB.open('files', 1);
                request.onupgradeneeded = function() {
                    console.log('storage.initialize.upgradeneeded()');
                    self.idb = request.result;
                    self.idb.createObjectStore('files');
                    resolve();
                };
                request.onsuccess = function() {
                    console.log('storage.initialize.success()');
                    self.idb = request.result;
                    resolve();
                };
                request.onerror = function() {
                    console.log('storage.initialize.error()');
                    console.error(request.error);
                    reject();
                };
            } catch (error) {
                console.error(error);
                reject();
            }
        });
    }

    blobs() {
        if (this.log) console.log('storage.blobs()');
        let self = this;

        return new Promise(function(resolve, reject) {
            let result;
            let transaction = self.idb.transaction(['files'], 'readonly');
            transaction.oncomplete = () => {
                resolve(result);
            };
            transaction.onerror = event => reject(event.target.error);

            let request = transaction.objectStore('files').getAllKeys();
            request.onsuccess = () => result = request.result;
        });
    }

    hasBlob(key) {
        if (this.log) console.log('storage.hasBlob(' + key + ')');
        let self = this;

        // https://stackoverflow.com/questions/15306611/check-if-indexeddb-objectstore-already-contains-key
        return new Promise(function(resolve, reject) {
            try {
                let transaction = self.idb.transaction(['files'], 'readonly');
                let request = transaction.objectStore('files').openCursor(key);
                request.onsuccess = function(request) {
                    var cursor = request.target.result;
                    if (cursor) {
                        // Key exists
                        resolve(true);
                    } else {
                        // Key does not exist
                        resolve(false);
                    }
                }
                request.onerror = function(error) {
                    console.error(error);
                    reject();
                }
            } catch (error) {
                console.error(error);
                reject();
            }
        });
    }

    getBlob(key) {
        if (this.log) console.log('storage.getBlob(' + key + ')');
        let self = this;

        return new Promise(function(resolve, reject) {
            try {
                if (self.hasBlob(key)) {
                    let transaction = self.idb.transaction(['files'], 'readonly');
                    let request = transaction.objectStore('files').get(key);
                    request.onsuccess = function(request) {
                        if (request.target.result) {
                            request.target.result.arrayBuffer().then((result) => {
                                resolve(result);
                            });
                        } else {
                            reject();
                        }
                    }
                    request.onerror = function() {
                        console.error(request.error);
                        reject();
                    };
                }
            } catch (error) {
                console.error(error);
                reject();
            }
        });
    }

    getBlobBytes(key) {
        if (this.log) console.log('storage.getBlobBytes(' + key + ')');
        let self = this;

        return new Promise(function(resolve, reject) {
            try {
                if (self.hasBlob(key)) {
                    let transaction = self.idb.transaction(['files'], 'readonly');
                    let request = transaction.objectStore('files').get(key);
                    request.onsuccess = function(request) {
                        if (request.target && request.target.result) {
                            resolve( request.target.result );
                        } else {
                            // Not found
                            console.error( 'Blob with key ' +key + ' was not found' );
                            reject();
                        }
                    };
                    request.onerror = function() {
                        console.error(request.error);
                        reject();
                    };
                } else {
                    // Not found
                    console.error( 'Blob with key ' +key + ' was not found' );
                    reject();
                }
            } catch (error) {
                console.error(error);
                reject();
            }
        });
    }

    loadBlob(key, id) {
        if (this.log) console.log('storage.loadBlob(' + key + ',' + id + ')');
        let self = this;

        return new Promise(function(resolve, reject) {
            try {
                if (self.hasBlob(key)) {
                    let transaction = self.idb.transaction(['files'], 'readonly');
                    let request = transaction.objectStore('files').get(key);
                    request.onsuccess = function(request) {
                        let el = document.getElementById(id);
                        if (el) {
                            if (request.target && request.target.result) {
                                el.src = window.URL.createObjectURL(new Blob([request.target.result], { type: request.target.result.type }));
                            } else {
                                // Not found
                                el.src = 'data:image/png;base64,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';
                            }
                            resolve();
                        } else {
                            console.error(new Error('An element with id "' + id + '" was not found.'));
                            reject();
                        }
                    };
                    request.onerror = function() {
                        console.error(request.error);
                        reject();
                    };
                } else {
                    let el = document.getElementById(id);
                    if (el) {
                        el.src = 'data:image/png;base64,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';
                    }
                    resolve();
                }
            } catch (error) {
                console.error(error);
                reject();
            }
        });
    }

    setBlob(key, blob, emitEvent = false) {
        if (this.log) console.log('storage.setBlob(' + key + ',' + emitEvent + ')');
        let self = this;

        return new Promise(function(resolve, reject) {
            try {
                let transaction = self.idb.transaction(['files'], 'readwrite');
                let request = transaction.objectStore('files').put(blob, key);
                request.onsuccess = function() {
                    if (emitEvent) {
                        // Send an event so other components can react to this if necessary
                        window.dispatchEvent(new CustomEvent('storage-changed', {
                            detail: {
                                action: 'setBlob',
                                key: key
                            }
                        }));
                    }
                    resolve();
                };
                request.onerror = function() {
                    console.error(request.error);
                    reject();
                };
            } catch (error) {
                console.error(error);
                reject();
            }
        });
    }

    saveCanvasAsBlob(key, canvas) {
        if (this.log) console.log('storage.saveCanvasAsBlob(' + key + ')');
        let self = this;

        return new Promise(function(resolve, reject) {
            canvas.toBlob((blob) => {
                self.setBlob(key, blob).then(() => {
                    resolve(key);
                }).catch(() => {
                    reject();
                });
            }, 'image/jpeg', 0.9);
        });
    }

    removeBlob(key, emitEvent = false) {
        if (this.log) console.log('storage.removeBlob(' + key + ',' + emitEvent + ')');
        let self = this;

        return new Promise(function(resolve, reject) {
            try {
                let transaction = self.idb.transaction(['files'], 'readwrite');
                let request = transaction.objectStore('files').delete(key);
                transaction.oncomplete = function() {
                    if (emitEvent) {
                        // Send an event so other components can react to this if necessary
                        window.dispatchEvent(new CustomEvent('storage-changed', {
                            detail: {
                                action: 'removeBlob',
                                key: key
                            }
                        }));
                    }
                    resolve(true);
                };
                transaction.onerror = function() {
                    console.error(request.error);
                    resolve(false);
                };
            } catch (error) {
                console.error(error);
                reject();
            }
        });
    }

    keys() {
        let result = [];
        for (let i = 0; i < localStorage.length; i++) {
            result.push(localStorage.key(i));
        }
        return result;
    }

    has(key) {
        if (localStorage[key]) {
            return true;
        } else {
            return false;
        }
    }

    get(key) {
        if (this.log) console.log('storage.get(' + key + ')');
        let content = localStorage.getItem(key);

        try {
            let contentObj = JSON.parse(content);
            return contentObj;
        } catch (error) {
            // console.error(error); - don't report any errors, just return the original value
            return content;
        }
    }

    getAll(key) {
        // Return all key/value pairs where key starts with key
        if (this.log) console.log('storage.getAll(' + key + ')');
        let self = this;

        let result = [];
        let keys = self.keys();
        for (let k in keys) {
            if (keys[k].substring(0, key.length) == key) {
                result.push(self.get(keys[k]));
            }
        }

        return result;
    }

    set(key, value, emitEvent = false) {
        if (this.log) console.log('storage.set(' + key + ',' + value + ',' + emitEvent + ')');
        let content = value;

        try {
            if (typeof value == 'object') {
                content = JSON.stringify(value);
            }
            localStorage.setItem(key, content);

            if (emitEvent) {
                // Send an event so other components can react to this if necessary
                window.dispatchEvent(new CustomEvent('storage-changed', {
                    detail: {
                        action: 'set',
                        key: key,
                        content: content
                    }
                }));
            }
            return value;
        } catch (error) {
            console.error(error);
            return value;
        }
    }

    remove(key, emitEvent = false) {
        if (this.log) console.log('storage.remove(' + key + ',' + emitEvent + ')');

        try {
            localStorage.removeItem(key);

            if (emitEvent) {
                // Send an event so other components can react to this if necessary
                window.dispatchEvent(new CustomEvent('storage-changed', {
                    detail: {
                        action: 'remove',
                        key: key
                    }
                }));
            }
        } catch (error) {
            console.error(error);
        }
        return true;
    }

    addTo(key, content, emitEvent = false) {
        if (this.log) console.log('storage.addTo(' + key + ',' + emitEvent + ')');
        let self = this;

        try {
            let original_value = self.get(key);
            if (!original_value) {
                original_value = [];
            }
            original_value.push(content);
            self.set(key, original_value);

            if (emitEvent) {
                // Send an event so other components can react to this if necessary
                window.dispatchEvent(new CustomEvent('storage-changed', {
                    detail: {
                        action: 'addTo',
                        key: key,
                        content: content
                    }
                }));
            }
            return true;
        } catch (error) {
            console.error(error);
            return false;
        }
    }

    getFrom(key, code) {
        if (this.log) console.log('storage.getFrom(' + key + ',' + code + ')');
        let self = this;

        try {
            let value = self.get(key);
            if (value) {
                return value[code];
            } else {
                return null;
            }
        } catch (error) {
            console.error(error);
            return null;
        }
    }

    setIn(key, code, content, emitEvent = false) {
        if (this.log) console.log('storage.setIn(' + key + ',' + code + ',<content>,' + emitEvent + ')');
        let self = this;

        try {
            let original_value = self.get(key);
            if (!original_value) {
                original_value = {};
            }
            original_value[code] = content;
            self.set(key, original_value);

            if (emitEvent) {
                // Send an event so other components can react to this if necessary
                window.dispatchEvent(new CustomEvent('storage-changed', {
                    detail: {
                        action: 'setIn',
                        key: key,
                        code: code,
                        content: content
                    }
                }));
            }
            return true;
        } catch (error) {
            console.error(error);
            return false;
        }
    }

    removeFrom(key, code, emitEvent = false) {
        if (this.log) console.log('storage.removeFrom(' + key + ',' + code + ',' + emitEvent + ')');
        let self = this;

        try {
            let original_value = self.get(key);
            if (!original_value) {
                return true;
            }
            delete original_value[code];
            self.set(key, original_value);

            if (emitEvent) {
                // Send an event so other components can react to this if necessary
                window.dispatchEvent(new CustomEvent('storage-changed', {
                    detail: {
                        action: 'removeFrom',
                        key: key,
                        code: code
                    }
                }));
            }
            return true;
        } catch (error) {
            console.error(error);
            return false;
        }
    }

    unset(key, emitEvent = false) {
        if (this.log) console.log('storage.unset(' + key + ',' + emitEvent + ')');

        try {
            localStorage.removeItem(key);

            if (emitEvent) {
                // Send an event so other components can react to this if necessary
                window.dispatchEvent(new CustomEvent('storage-changed', {
                    detail: {
                        action: 'unset',
                        key: key
                    }
                }));
            }
            return true;
        } catch (error) {
            console.error(error);
            return false;
        }
    }

    clear(emitEvent = false) {
        if (this.log) console.log('storage.clear(' + emitEvent + ')');

        try {
            localStorage.clear();

            if (emitEvent) {
                // Send an event so other components can react to this if necessary
                window.dispatchEvent(new CustomEvent('storage-changed', {
                    detail: {
                        action: 'clear'
                    }
                }));
            }
            return true;
        } catch (error) {
            console.error(error);
            return false;
        }
    }

    base64_to_blob(dataURL) {
        if (this.log) console.log('based64_to_blob()');

        const BASE64_MARKER = ';base64,';
        const parts = dataURL.split(BASE64_MARKER);
        const contentType = parts[0].split(':')[1];
        const raw = window.atob(parts[1]);
        const rawLength = raw.length;
        const uInt8Array = new Uint8Array(rawLength);

        for (let i = 0; i < rawLength; ++i) {
            uInt8Array[i] = raw.charCodeAt(i);
        }

        return new Blob([uInt8Array], { type: contentType });
    }
}